import * as React from 'react';
import '../../../../../styles/PropertiesPage.css';
import Modal from 'reactstrap/lib/Modal';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalFooter from 'reactstrap/lib/ModalFooter';

export interface Props {
    visible: boolean;
    closeNoPropertiesFoundModal: () => void;
    clearSearch: () => void;
}

const NoPropertiesFoundModal = (props: Props) => {
    return (
        <Modal
            className="no-properties-modal"
            isOpen={props.visible}
            toggle={props.closeNoPropertiesFoundModal}
        >
            <ModalBody>No properties were found for this search.</ModalBody>
            <ModalFooter className="text-button">
                <div onClick={props.clearSearch}>Search again</div>
            </ModalFooter>
        </Modal>
    );
};

export default NoPropertiesFoundModal;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/public/properties/NoPropertiesFoundModal.tsx